import Default from '@app/constants';
import { FilterBatteries } from '@app/typings/services/winnonie/battery';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const filterBatteries: string = 'winnonie/batteries.filters';

export const setFilterBatteriesWinnonie = (value: FilterBatteries) => {
  set(filterBatteries, value);
};

export const getFilterBatteriesWinnonie = (): FilterBatteries => {
  return (
    get(filterBatteries) || { filters: Default.filter.winnonie.batteries, pages: Default.pages }
  );
};

export const clearFilterBatteriesWinnonie = () => {
  return set(filterBatteries, {
    filters: Default.filter.winnonie.batteries,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterBatteriesWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
